var MIN_LENGTH_FOR_NSN = 2, MAX_LENGTH_FOR_NSN = 17, MAX_LENGTH_COUNTRY_CODE = 3, VALID_DIGITS = "0-9０-９٠-٩۰-۹", DASHES = "-‐-―−ー－", SLASHES = "／/", DOTS = "．.", WHITESPACE = "  ­​⁠　", BRACKETS = "()（）［］\\[\\]", TILDES = "~⁓∼～", VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES), PLUS_CHARS = "+＋";
export {
  MAX_LENGTH_COUNTRY_CODE,
  MAX_LENGTH_FOR_NSN,
  MIN_LENGTH_FOR_NSN,
  PLUS_CHARS,
  VALID_DIGITS,
  VALID_PUNCTUATION,
  WHITESPACE
};
//# sourceMappingURL=constants.js.map
